export default __webpack_public_path__ + "static/media/LAS0720.34I-37961_-22225_0.ea5fa7cf.jpg";